import React from "react";

const VendorDashboardStat1 = () => {
  return (
    <div>
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_171_26528)">
          <path
            d="M23.0596 3.93025C20.6878 1.55843 17.4112 0.0905762 13.7919 0.0905762C6.55336 0.0905762 0.684509 5.95943 0.684509 13.198C0.684509 20.4365 6.55336 26.3053 13.7919 26.3053C21.0304 26.3053 26.8993 20.4365 26.8993 13.198C26.8993 9.57868 25.4314 6.30206 23.0596 3.93025ZM20.3999 5.81614L22.7621 8.17833L13.896 17.0444L13.8949 17.0433L13.8937 17.0444L7.68621 10.8369L7.94528 10.5779L9.78141 8.74173L10.0484 8.47476L13.8949 12.3212L20.3999 5.81614Z"
            fill="#418CFF"
          />
        </g>
        <defs>
          <clipPath id="clip0_171_26528">
            <rect
              width="26.2148"
              height="26.2148"
              fill="white"
              transform="translate(0.684509 0.0905762)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default VendorDashboardStat1;
